import React, { useState } from 'react';
import { Container, Row, Card, Image, Col, Button, Modal } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { BsFillChatDotsFill } from 'react-icons/bs';  // Chat icon for the button

import '../css/Welcome.css';  // Import sidebar-specific CSS
import LoginButton from '../components/Login';
import Chat from './Chat';  // Import the Chat component

import myImage from '../images/image.png';  // Adjust the path to your image

import PresentIcon from '../components/PresentIcon';




const Welcome = ({showChat, setShowChat, handleChatToggle}) => {
  //const [showChat, setShowChat] = useState(false);

  // Function to handle the chat open/close
  //const handleChatToggle = () => setShowChat(!showChat);

  const [isConnected, setIsConnected] = useState(false);  // Connection status

  return (
    <Container className="mt-5">
      {/* Header Section */}

         {/* Header Section */}
         <Row className="text-center mb-5">
        <Col>
          <h1 className="display-4 text-primary">Wilkommen bei Present-Bot</h1>
          <p className="lead text-muted">
          Chatte mit unsererm present-bot, um die perfekten Geschenke für deine Liebsten zu finden.​
          </p>
        </Col>
      </Row>

      {/* Introductory Section */}
      <Row className="align-items-center mb-5">
        <Col md={6} xs={4} lg={2}>
          <Image
            //src="https://via.placeholder.com/600x400" // Replace with an actual image
            src={myImage}
            fluid
            rounded
          />
        </Col>
        <Col md={6}>
          <h2 className="text-secondary">Finde das perfekte Geschenk</h2>
          <p className="text-muted">
            {/*Whether it's a birthday, holiday, or any special occasion, our AI assistant is here to guide you. 
            Simply tell us a bit about the person and let our assistant recommend personalized, thoughtful gift ideas.*/}
            Egal, ob Geburtstag, Feiertag oder ein besonderer Anlass – unser KI-Assistent ist hier, um dich zu unterstützen.
            Erzähle uns einfach ein wenig über die Person, und unser Assistent wird dir personalisierte, durchdachte Geschenkideen vorschlagen
          </p>
          <Button variant="primary" size="lg" className="me-3 text-light" onClick={handleChatToggle}>
            Geschenksuche
          </Button>
          <LinkContainer to="/learn-more">
            <Button variant="outline-secondary" size="lg" to="/learn-more">
              Erfahre mehr 
            </Button>
          </LinkContainer>
        </Col>
      </Row>

      {/* Features Section */}
      <Row className="mb-5">
        <Col md={4}>
          <Card className="shadow-sm h-100">
            <Card.Body>
              <Card.Title className="text-primary">Personalisierte Vorschläge</Card.Title>
              <Card.Text className="text-muted">
                {/*Our AI uses information about your friends and family to tailor suggestions based on their preferences and interests.*/}
                Unsere KI nutzt Informationen über deine Freunde und Familie, um Vorschläge basierend auf ihren Vorlieben und Interessen zu personalisieren.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="shadow-sm h-100">
            <Card.Body>
              <Card.Title className="text-success">Echtzeit-Unterstützung</Card.Title>
              <Card.Text className="text-muted">
                Chatte mit unserem KI-Assistenten für Echtzeit-Vorschläge und Updates, damit du stets die neuesten Geschenkideen parat hast.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="shadow-sm h-100">
            <Card.Body>
              <Card.Title className="text-warning">Einfache Nutzung</Card.Title>
              <Card.Text className="text-muted">
              Unsere intuitive Benutzeroberfläche macht es für jeden leicht das perfekte Geschenk zu finden.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Call to Action */}
      <Row className="text-center mb-5">
        <Col>
          <h2 className="text-secondary">Let’s Get Started!</h2>
          <p className="text-muted">
          Erzähle uns von deinen Liebsten, und lass unseren KI-Assistenten dir helfen, das perfekte Geschenk zu finden.
          </p>
          <Button variant="primary" size="lg" className="me-3 text-light" onClick={handleChatToggle}>
            Chat mit Assistent
          </Button>
          <Button variant="outline-secondary" size="lg" href="/contact">
            Support
          </Button>
          {/*<LoginButton />*/}
        </Col>
      </Row>


      {/*<Chat 
        showChat={showChat}
        setShowChat={setShowChat}
      />*/}  {/* Use the Chat component */}


    </Container>
  );
};

export default Welcome;